import css from './createParameterSidePage.module.css'
import useHttpLoader from '@/shared/hooks/useHttpLoader'
import useStateWithChange from '@/shared/hooks/useStateWithChange'
import SidePage from '@/shared/SidePage'
import parametersApi from '../../parameters.api'
import { IParameterGroup, TCreateParameterDTO } from '../../parameters.types'
import parameterEvents from '../../events/parameter/parameter.events.ts'
import Button from '@/shared/Buttons/Button'
import SeparateLine from '@/shared/Forms/SeparateLine'
import ParameterFormFields from '../ParameterFormFields'
import parametersUtils from '../../parameters.utils'
import parametersGenerators from '@/pages/Parameters/parameters.generators.ts'
import { useEffect } from 'react'

interface IProps {
  open: boolean
  onClose: () => void
  initialParentId?: IParameterGroup['id']
}

const CreateParameterSidePage = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [parameter, setParameter, handleChange] = useStateWithChange<TCreateParameterDTO>(
    parametersGenerators.generateCreateParameterDTO(props.initialParentId)
  )

  useEffect(() => {
    setParameter(parametersGenerators.generateCreateParameterDTO(props.initialParentId))
  }, [props.initialParentId])

  const handleCreateParameter = () => {
    wait(parametersApi.createParameter(parameter), (resp) => {
      if (resp.status === 'success') {
        parameterEvents.created(resp.body)
        props.onClose()
      }
    })
  }

  return (
    <SidePage onClose={props.onClose} open={props.open} key="createParameterSidePage">
      <div className="flex-lines gap16" style={{ height: '100%' }}>
        <h4 className="text-heading-4">Создание переменной</h4>
        <SeparateLine />
        <div className={css.wrapperContent}>
          <ParameterFormFields parameter={parameter} handleChange={handleChange} />
          <div className={css.actions}>
            <Button
              size="default"
              type="default"
              text="Создать"
              onClick={handleCreateParameter}
              disabled={!parametersUtils.isCorrectFormParameterFields(parameter)}
              loading={loading}
            />
            <Button size="default" type="default" text="Отменить" onClick={props.onClose} disabled={loading} />
          </div>
        </div>
      </div>
    </SidePage>
  )
}

export default CreateParameterSidePage
